import React, { Component } from 'react'
import { Row, Col, Table, Icon, Popconfirm } from 'antd'
import { Link } from 'react-router-dom'

import Permissions from '../models/Permissions'

class AdminIssues extends Component {

    render() {
        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            render: (text, r) => (
                <span>
                    { r.status === 'Guardada' ? (<Icon type="exclamation-circle-o" style={{color: 'orange'}} />)
                        : r.status === 'Anulada' ? (<Icon type="close-circle-o" style={{color: 'red'}} />)
                        : (<Icon type="check-circle-o" style={{color: 'green'}} />)
                    }
                    <span>{' '}{r.status}</span>
                </span>
            )
        },
        {
            title: 'Concelho',
            dataIndex: 'concelho',
            key: 'concelho'
        },
        {
            title: 'Freguesia',
            dataIndex: 'freguesia',
            key: 'freguesia'
        },
        {
            title: 'Reportado Por',
            dataIndex: 'tecnico',
            key: 'tecnico'
        },
        {
            title: 'Data da Ocorrência',
            dataIndex: 'data_ocorrencia',
            key: 'data_ocorrencia'
        },
        {
            title: 'Última Atualização',
            dataIndex: 'data_registo',
            key: 'data_registo'
        },
        {
            title: 'Opções',
            key: 'action',
            render: (text, record) => (
                <span>
                    { !Permissions.isDenied('issues', 'update', record) ? (
                        <Link to={'/admin/issues/form/' + record.id}>
                            <Icon type="edit" style={{color: 'green'}} />
                        </Link>
                    ) : '' }
                    <span className="ant-divider" />
                    <Popconfirm title="DESTRUIR? Não poderá voltar atrás."
                        onConfirm={(e) => this.props.remove(record)}
                        okText="Sim" cancelText="Não">
                        <a role="button">
                            <Icon type="delete" style={{color: 'red'}} />
                        </a>
                    </Popconfirm>
                </span>
            )
        }]
        this.props.items.map((item) => {
            item.key = item.id
            return item
        })
        return (
            <Row>
                <Col span={24}>
                    <Table dataSource={this.props.items} columns={columns} />
                </Col>
            </Row>
        )
    }
}

export default AdminIssues;



// WEBPACK FOOTER //
// ./src/components/AdminIssues.js